module.exports = __webpack_public_path__ + "img/book.c3cb1dea.svg";